import { Button, LinearProgress, Pagination, Paper, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TableRow, Box, Typography } from '@mui/material';
import { useEffect, useMemo, useState } from 'react';
import { useNavigate, useSearchParams } from "react-router-dom";

import { AlertSnackBar, FerramentasDaListagem } from "../../shared/components";
import { DialogConfirm } from '../../shared/components/dialog/DialogConfirm';
import { Environment } from '../../shared/environment';
import { LayoutBaseDePagina } from "../../shared/layouts";
import { IPaginacao } from '../../shared/services/api/axios-config';
import { ClienteService, ICliente } from '../../shared/services/api/cliente/ClienteService';

export const ListagemDeClienteDesativado: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  const [alert, setAlert] = useState<{ tipoAlert: string, mensagem: string } | undefined>(undefined);
  const [duracaoAlert, setDuracaoAlert] = useState<number>(Environment.DURACAO_ALERT + 500);

  const [rows, setRows] = useState<ICliente[]>([]);
  const [paginacao, setPaginacao] = useState<IPaginacao>({
    totalCount: 0,
    pageSize: 0,
    currentPage: 0,
    totalPages: 0,
    hasNext: false,
    hasPrevious: false
  });
  const [isLoading, setIsLoading] = useState(true);

  const pagina = useMemo(() => {
    return Number(searchParams.get('pagina') || '1');
  }, [searchParams]);

  useEffect(() => {
    setIsLoading(true);
    // adiciona um delay para fazer a busca

    ClienteService.getAll(pagina, false).then((result) => {
      setIsLoading(false);

      if (result instanceof Error) {//verificar se deu erro
        setAlert({ tipoAlert: "erro", mensagem: result.message });
        setTimeout(() => {
          setAlert(undefined);
        }, duracaoAlert);
      }
      else {
        setPaginacao(result.paginacao);
        setRows(result.clientes);
      }
    })
  }, [pagina]);

  const handleReable = () => {
    setAbrir(false);
    setIsLoading(true);
    ClienteService.toggleEnabledByCnpj(idToReable).then(result => {
      setIsLoading(false);
      if (result instanceof Error) {//verificar se deu erro
        setAlert({ tipoAlert: "erro", mensagem: result.message });
        setTimeout(() => {
          setAlert(undefined);
        }, duracaoAlert);
      } else {
        setRows(oldRows => {
          return [
            ...oldRows.filter(oldRow => oldRow.cnpj !== idToReable),
          ]
        });
        setAlert({ tipoAlert: "sucesso", mensagem: "Unidade reativada" });
        setTimeout(() => {
          setAlert(undefined);
        }, duracaoAlert);
      }
    });
  }

  const [abrir, setAbrir] = useState(false);
  const [idToReable, setidToReable] = useState<string>("");

  const handleClickReable = (cnpj: string) => {
    setAbrir(true);
    setidToReable(cnpj);
  };

  const handleCancel = () => {
    setAbrir(false);
  };


  return (
    <LayoutBaseDePagina
      titulo="Listagem de unidades desativadas"
      barraDeFerramentas={
        <FerramentasDaListagem
          aoClicarEmVoltar={() => navigate(-1)}
          aoClicarEmNovo={() => navigate('/cliente/detalhe/novo')}
        />
      }
    >
      {alert !== undefined && (
        <>
          {alert.tipoAlert === "sucesso" && (
            <AlertSnackBar gravidade="success" mensagem={alert.mensagem} returnedDuration={duracao => setDuracaoAlert(duracao + 500)} />
          )}
          {alert.tipoAlert === "erro" && (
            <AlertSnackBar gravidade="error" mensagem={alert.mensagem} returnedDuration={duracao => setDuracaoAlert(duracao + 500)} />
          )}
          {alert.tipoAlert === "aviso" && (
            <AlertSnackBar gravidade="warning" mensagem={alert.mensagem} returnedDuration={duracao => setDuracaoAlert(duracao + 500)} />
          )}
        </>
      )}

      <DialogConfirm
        AoConfirmar={handleReable}
        titulo={"Dejesa realmente reativar a unidade?"}
        texto={"Ao confirmar, a unidade e tudo o que lhe pertence passará a está ativo."}
        abrir={abrir}
        AoCancelar={handleCancel}
      />

      <TableContainer component={Paper} variant="outlined" sx={{ m: 1, width: 'auto' }}>
        <Table>
          <TableHead>
            <TableRow>

              <TableCell> Nome </TableCell>
              <TableCell> CNPJ </TableCell>
              <TableCell> Ações </TableCell>

            </TableRow>
          </TableHead>
          <TableBody>

            {rows.map(row => (
              <TableRow key={row.cnpj}>
                <TableCell> {row.nome} </TableCell>
                <TableCell> {row.cnpj.substring(0, 2) + "." + row.cnpj.substring(2, 5) + "." + row.cnpj.substring(5, 8) + "/" + row.cnpj.substring(8, 12) + "-" + row.cnpj.substring(12)} </TableCell>
                <TableCell>
                  <Button
                    color="primary"
                    disableElevation
                    variant="contained"
                    onClick={() => handleClickReable(row.cnpj)}
                  >
                    Reativar
                  </Button>
                </TableCell>
              </TableRow>
            ))}

          </TableBody>

          {paginacao.totalCount === 0 && !isLoading && (
            <caption> {Environment.LISTAGEM_VAZIA} </caption>
          )}

          <TableFooter>
            {isLoading && (
              <TableRow>
                <TableCell colSpan={3}>{/* quantas colunas o loading vai ocupar */}
                  <LinearProgress variant='indeterminate' />
                </TableCell>
              </TableRow>
            )}
            {paginacao.totalPages > 1 && (
              <TableRow>
                <TableCell colSpan={3} align="right">
                  <Box flexDirection="row" display="inline-flex">
                    <Typography noWrap marginTop={0.5} >Exibindo {paginacao.hasNext ? paginacao.pageSize * paginacao.currentPage : paginacao.totalCount} de {paginacao?.totalCount}</Typography>
                    <Pagination
                      page={pagina}
                      count={paginacao?.totalPages}
                      onChange={(_, newPage) => setSearchParams({ pagina: newPage.toString() }, { replace: true })}
                    />
                  </Box>
                </TableCell>
              </TableRow>
            )}
          </TableFooter>
        </Table>
      </TableContainer>
    </LayoutBaseDePagina>
  )
}